export const mapboxAccessToken =
    import.meta.env.VITE_MAPBOX_TOKEN ??
    window.localStorage.getItem("centerreach.mapboxToken") ??
    "";

export const mapStyle =
    import.meta.env.VITE_MAPBOX_STYLE ?? "mapbox://styles/mapbox/streets-v12";

/** High-contrast style used for A4 print exports — streets-v12 keeps roads clearly visible. */
export const printMapStyle =
    import.meta.env.VITE_MAPBOX_PRINT_STYLE ?? "mapbox://styles/mapbox/streets-v12";

/** Satellite / aerial imagery with roads and labels (toggle target in MapView). */
export const mapboxSatelliteStyle =
    import.meta.env.VITE_MAPBOX_SATELLITE_STYLE ?? "mapbox://styles/mapbox/satellite-streets-v12";

export const mapInitialView = {
    center: [17.952699028908405, 59.23739880839171] as [number, number], // Vistabergs allé 37, Huddinge
    zoom: 16 // More zoomed in to reduce initial data load
};